import { skipToken } from "@reduxjs/toolkit/query";
import { createContext, useMemo } from "react";
import { useParams } from "react-router-dom";
import { useGetVisitQuery } from "src/api/services/visitApi";
import { OnlineVisit } from "src/api/types";
import { MatchParam } from "src/constants/matches";

export const VisitContext = createContext<OnlineVisit | null>(null);

interface Props {
  children: React.ReactNode;
}
const VisitProvider = ({ children }: Props) => {
  const { visitId } = useParams<MatchParam<"VISIT_ID">>();
  const { data } = useGetVisitQuery(visitId ?? skipToken);

  const visit = useMemo(() => {
    if (data == null || data.status === "canceled") return null;

    return data;
  }, [data]);

  if (visit == null) {
    return null;
  }

  return (
    <VisitContext.Provider value={visit}>{children}</VisitContext.Provider>
  );
};

export default VisitProvider;
